import { render, staticRenderFns } from "./RateYourLevel.vue?vue&type=template&id=018d6946&scoped=true&"
import script from "./RateYourLevel.vue?vue&type=script&lang=js&"
export * from "./RateYourLevel.vue?vue&type=script&lang=js&"
import style0 from "./RateYourLevel.vue?vue&type=style&index=0&id=018d6946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018d6946",
  null
  
)

export default component.exports